import React from 'react';
import { AgentDefinition, SdlcGroup, SDLC_GROUP_META } from '../types';
import { AgentTile } from './AgentTile';

interface SDLCGroupSectionProps {
  group: SdlcGroup;
  agents: AgentDefinition[];
  onChatClick: (agent: AgentDefinition) => void;
}

export const SDLCGroupSection: React.FC<SDLCGroupSectionProps> = ({ group, agents, onChatClick }) => {
  const meta = SDLC_GROUP_META[group];

  return (
    <div className="quicklinks-section agent-catalog-section">
      <div className="quicklinks-section-title agent-catalog-section__title">
        <span className="agent-catalog-section__icon">{meta.icon}</span>
        {meta.label}
      </div>
      <div className="quicklinks-grid agent-catalog-grid">
        {agents.map((agent) => (
          <AgentTile key={agent.id} agent={agent} onChatClick={onChatClick} />
        ))}
      </div>
    </div>
  );
};
